import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=64efd9e8&scoped=true&lang=pug&"
var script = {}
import style0 from "./terms.vue?vue&type=style&index=0&id=64efd9e8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64efd9e8",
  null
  
)

export default component.exports